import { corporationTypeType, HasBedFunctionReportType, HasCodeType, hospitalClinicKbnType, OutputSettingType, TaxAccountingMethodType } from '@/views/corporation-info/types'

type SelectOption = {
  code: string;
  displayName: string;
}

/**
 * 法人タイプ
 */
export const corporationTypes: SelectOption[] = [
  { code: corporationTypeType.Type1, displayName: '診療所のみ開設している医療法人' },
  { code: corporationTypeType.Type2, displayName: '病院、老健または介護医療院のいずれか又は複数を開設している医療法人' },
  { code: corporationTypeType.Type3, displayName: '医療法第51条第２項に該当する（BS負債20億以上又はPL収益10億以上等）社会医療法人' },
  { code: corporationTypeType.Type4, displayName: '医療法第51条第２項に該当しない社会医療法人' },
  { code: corporationTypeType.Type5, displayName: '医療法第51条第２項に該当する（BS負債50億以上又はPL収益70億以上）医療法人' },
  { code: corporationTypeType.Type6, displayName: '地域医療連携推進法人' }
]

/**
 * 都道府県番号
 */
export const prefectures: SelectOption[] = [
  { code: '01', displayName: '01：北海道' },
  { code: '02', displayName: '02：青森県' },
  { code: '03', displayName: '03：岩手県' },
  { code: '04', displayName: '04：宮城県' },
  { code: '05', displayName: '05：秋田県' },
  { code: '06', displayName: '06：山形県' },
  { code: '07', displayName: '07：福島県' },
  { code: '08', displayName: '08：茨城県' },
  { code: '09', displayName: '09：栃木県' },
  { code: '10', displayName: '10：群馬県' },
  { code: '11', displayName: '11：埼玉県' },
  { code: '12', displayName: '12：千葉県' },
  { code: '13', displayName: '13：東京都' },
  { code: '14', displayName: '14：神奈川県' },
  { code: '15', displayName: '15：新潟県' },
  { code: '16', displayName: '16：富山県' },
  { code: '17', displayName: '17：石川県' },
  { code: '18', displayName: '18：福井県' },
  { code: '19', displayName: '19：山梨県' },
  { code: '20', displayName: '20：長野県' },
  { code: '21', displayName: '21：岐阜県' },
  { code: '22', displayName: '22：静岡県' },
  { code: '23', displayName: '23：愛知県' },
  { code: '24', displayName: '24：三重県' },
  { code: '25', displayName: '25：滋賀県' },
  { code: '26', displayName: '26：京都府' },
  { code: '27', displayName: '27：大阪府' },
  { code: '28', displayName: '28：兵庫県' },
  { code: '29', displayName: '29：奈良県' },
  { code: '30', displayName: '30：和歌山県' },
  { code: '31', displayName: '31：鳥取県' },
  { code: '32', displayName: '32：島根県' },
  { code: '33', displayName: '33：岡山県' },
  { code: '34', displayName: '34：広島県' },
  { code: '35', displayName: '35：山口県' },
  { code: '36', displayName: '36：徳島県' },
  { code: '37', displayName: '37：香川県' },
  { code: '38', displayName: '38：愛媛県' },
  { code: '39', displayName: '39：高知県' },
  { code: '40', displayName: '40：福岡県' },
  { code: '41', displayName: '41：佐賀県' },
  { code: '42', displayName: '42：長崎県' },
  { code: '43', displayName: '43：熊本県' },
  { code: '44', displayName: '44：大分県' },
  { code: '45', displayName: '45：宮崎県' },
  { code: '46', displayName: '46：鹿児島県' },
  { code: '47', displayName: '47：沖縄県' }
]

/**
 * 病院・診療所区分
 */
export const hospitalClinicKbns: SelectOption[] = [
  { code: hospitalClinicKbnType.Hospital, displayName: '様式１（病院）' },
  { code: hospitalClinicKbnType.Clinic, displayName: '様式２（診療所）' },
  { code: hospitalClinicKbnType.NonReportable, displayName: '様式３（報告対象外の医療法人）' }
]

/**
 * 有無
 */
export const hasCodes: SelectOption[] = [
  { code: HasCodeType.Yes, displayName: '有' },
  { code: HasCodeType.No, displayName: '無' }
]

/**
 * 消費税の経理方式
 */
export const taxAccountingMethods: SelectOption[] = [
  { code: TaxAccountingMethodType.Excluded, displayName: '税抜' },
  { code: TaxAccountingMethodType.Included, displayName: '税込' }
]

/**
 * 「病床機能報告」報告の有無
 */
export const hasBedFunctionReports: SelectOption[] = [
  { code: HasBedFunctionReportType.YesWithoutDispatch, displayName: '有（派遣を含まない）' },
  { code: HasBedFunctionReportType.YesWithDispatch, displayName: '有（派遣を含む）' },
  { code: HasBedFunctionReportType.No, displayName: '無' }
]

/**
 * 診療科
 */
export const specialties: SelectOption[] = [
  { code: '01内科', displayName: '内科' },
  { code: '02呼吸器内科', displayName: '呼吸器内科' },
  { code: '03循環器内科', displayName: '循環器内科' },
  { code: '04消化器内科（胃腸内科）', displayName: '消化器内科（胃腸内科）' },
  { code: '05腎臓内科', displayName: '腎臓内科' },
  { code: '06神経内科', displayName: '神経内科' },
  { code: '07糖尿病内科（代謝内科）', displayName: '糖尿病内科（代謝内科）' },
  { code: '08血液内科', displayName: '血液内科' },
  { code: '09皮膚科', displayName: '皮膚科' },
  { code: '10アレルギー科', displayName: 'アレルギー科' },
  { code: '11リウマチ科', displayName: 'リウマチ科' },
  { code: '12感染症内科', displayName: '感染症内科' },
  { code: '13小児科', displayName: '小児科' },
  { code: '14精神科', displayName: '精神科' },
  { code: '15心療内科', displayName: '心療内科' },
  { code: '16外科', displayName: '外科' },
  { code: '17呼吸器外科', displayName: '呼吸器外科' },
  { code: '18心臓血管外科', displayName: '心臓血管外科' },
  { code: '19乳腺外科', displayName: '乳腺外科' },
  { code: '20気管食道外科', displayName: '気管食道外科' },
  { code: '21消化器外科（胃腸外科）', displayName: '消化器外科（胃腸外科）' },
  { code: '22泌尿器科', displayName: '泌尿器科' },
  { code: '23肛門外科', displayName: '肛門外科' },
  { code: '24脳神経外科', displayName: '脳神経外科' },
  { code: '25整形外科', displayName: '整形外科' },
  { code: '26形成外科', displayName: '形成外科' },
  { code: '27美容外科', displayName: '美容外科' },
  { code: '28眼科', displayName: '眼科' },
  { code: '29耳鼻咽喉科', displayName: '耳鼻咽喉科' },
  { code: '30小児外科', displayName: '小児外科' },
  { code: '31産婦人科', displayName: '産婦人科' },
  { code: '32産科', displayName: '産科' },
  { code: '33婦人科', displayName: '婦人科' },
  { code: '34リハビリテーション科', displayName: 'リハビリテーション科' },
  { code: '35放射線科', displayName: '放射線科' },
  { code: '36麻酔科', displayName: '麻酔科' },
  { code: '37病理診断科', displayName: '病理診断科' },
  { code: '38臨床検査科', displayName: '臨床検査科' },
  { code: '39救急科', displayName: '救急科' },
  { code: '40歯科', displayName: '歯科' },
  { code: '41矯正歯科', displayName: '矯正歯科' },
  { code: '42小児歯科', displayName: '小児歯科' },
  { code: '43歯科口腔外科', displayName: '歯科口腔外科' },
  { code: '44その他の診療科', displayName: 'その他の診療科' }
]

/**
 * 出力設定
 */
export const outputSettings: SelectOption[] = [
  { code: OutputSettingType.All, displayName: '全社' },
  { code: OutputSettingType.BmnGroup, displayName: '部門グループ' }
]
